// extracted by mini-css-extract-plugin
export default {"mainSection":"Main_mainSection__5xfHv","photo":"Main_photo__vXyQE","MainContainer":"Main_MainContainer__m2+jJ","text":"Main_text__qONbS","downloadCV":"Main_downloadCV__08KlE"};